import { render, staticRenderFns } from "./TheDashboardFooter.vue?vue&type=template&id=cfd8f646&scoped=true&"
import script from "./TheDashboardFooter.vue?vue&type=script&lang=js&"
export * from "./TheDashboardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd8f646",
  null
  
)

export default component.exports